import React from "react";
import styles from "./TransactionsTable.module.css";

const TransactionsTable = ({
  transactions,
  pagination,
  currentPage,
  onPageChange,
}) => {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const renderPagination = () => {
    const pageNumbers = [];

    // Add first page and ellipsis if needed
    if (currentPage > 3) {
      pageNumbers.push(1);
      if (currentPage > 4) pageNumbers.push("...");
    }

    // Add pages around current page
    for (
      let i = Math.max(1, currentPage - 1);
      i <= Math.min(pagination.max_pages, currentPage + 1);
      i++
    ) {
      pageNumbers.push(i);
    }

    // Add ellipsis and last page if needed
    if (currentPage < pagination.max_pages - 2) {
      if (currentPage < pagination.max_pages - 3) pageNumbers.push("...");
      pageNumbers.push(pagination.max_pages);
    }

    return (
      <div className={styles.pagination}>
        <button
          className={styles.paginationButton}
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          &lt;
        </button>
        {pageNumbers.map((page, index) => (
          <button
            key={index}
            className={`${styles.paginationButton} ${
              page === currentPage ? styles.active : ""
            }`}
            onClick={() => typeof page === "number" && onPageChange(page)}
            disabled={typeof page !== "number"}
          >
            {page}
          </button>
        ))}
        <button
          className={styles.paginationButton}
          disabled={currentPage === pagination.max_pages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          &gt;
        </button>
      </div>
    );
  };

  return (
    <>
      {transactions && transactions.length > 0 ? (
        <>
          <table className={styles.transactionTable}>
            <thead>
              <tr>
                <th>Customer Name</th>
                <th>Product</th>
                <th>Workshop title</th>
                <th>Session title</th>
                <th>Paid</th>
                <th>Expert earning</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((transaction) => (
                <tr key={transaction.id}>
                  <td>{transaction.user_name}</td>
                  <td>{transaction.workshop_title ? "Workshop" : "Session"}</td>
                  <td>{transaction.workshop_title || "-"}</td>
                  <td>{transaction.session_title || "-"}</td>
                  <td>
                    ₹{" "}
                    {transaction.workshop_purchase_price ||
                      transaction.session_purchase_price ||
                      "0"}
                  </td>
                  <td>₹ {transaction.expert_earning || "0"}</td>
                  <td>{formatDate(transaction.purchase_date)}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className={styles.paginationContainer}>
            <div className={styles.showingEntries}>
              Showing data 1 to {Math.min(10, transactions.length)} of{" "}
              {pagination.total_count} entries
            </div>
            {renderPagination()}
          </div>
        </>
      ) : (
        <p>No transaction information available</p>
      )}
    </>
  );
};

export default TransactionsTable;
